const SELF_EXCLUDED_PARAMS = {
  login_success: 'false',
  error: 'authorization',
  error_description: ['self_excluded', 'self_excluded_gamstop', 'login_no_possible_selfban'],
} as const;

function isSelfExclusionLoginError(errorDescription: string | undefined): boolean {
  return SELF_EXCLUDED_PARAMS.error_description.some(value => value === errorDescription);
}

function isSelfExcluded(searchParams: Pick<URLSearchParams, 'get'>): boolean {
  const errorDescription = searchParams.get('error_description');

  return (
    searchParams.get('login_success') === SELF_EXCLUDED_PARAMS.login_success &&
    searchParams.get('error') === SELF_EXCLUDED_PARAMS.error &&
    isSelfExclusionLoginError(errorDescription ?? undefined)
  );
}

export { isSelfExcluded, isSelfExclusionLoginError };
